import {useAtomValue, useSetAtom} from "jotai";

import {
  joinClassroomDialogOpenAtom,
  setJoinClassroomDialogOpenAtom,
  newClassroomAtom,
  setNewClassroomAtom,
  quickCreateClassroomOpenAtom,
  setQuickCreateClassroomOpenAtom,
  memberLimitAtom,
} from "../atoms/classroomAtoms";

export default function useClassroom() {
  const joinClassroomDialogOpen = useAtomValue(joinClassroomDialogOpenAtom);
  const setIsJoinClassroomDialogOpen = useSetAtom(
    setJoinClassroomDialogOpenAtom,
  );
  const newClassroom = useAtomValue(newClassroomAtom);
  const setNewClassroom = useSetAtom(setNewClassroomAtom);
  const quickCreateClassroomOpen = useAtomValue(quickCreateClassroomOpenAtom);
  const setQuickCreateClassroomOpen = useSetAtom(
    setQuickCreateClassroomOpenAtom,
  );
  const memberLimit = useAtomValue(memberLimitAtom);

  return {
    joinClassroomDialogOpen,
    setIsJoinClassroomDialogOpen,
    newClassroom,
    setNewClassroom,
    quickCreateClassroomOpen,
    setQuickCreateClassroomOpen,
    memberLimit,
  };
}
